module.exports = __webpack_public_path__ + "img/electronic.88e23030.jpg";